import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import {
  getAllRoleGroups,
  addRoleGroup,
  updateRoleGroup,
  deleteRoleGroup
} from "../services/roleGroupService";
import { toast } from 'react-toastify';

const RoleGroups = () => {
  const [roleGroups, setRoleGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [deletingGroup, setDeletingGroup] = useState(null);
  const [form] = Form.useForm();

  const fetchRoleGroups = async () => {
    setLoading(true);
    try {
      const groupList = await getAllRoleGroups();
      setRoleGroups(groupList);
    } catch {
      message.error("Rol grupları alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let response;
      if (editingGroup) {
        response = await updateRoleGroup({ ...editingGroup, ...values });
      } else {
        response = await addRoleGroup(values);
      }

      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "İşlem başarılı.");
      } else {
        toast.error(response?.Message || "İşlem başarısız.");
      }

      fetchRoleGroups();
      setIsModalOpen(false);
      form.resetFields();
      setEditingGroup(null);
    } catch (error) {
      const msg = error?.response?.data?.Message || "İşlem sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteRoleGroup(id);
      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "Silme başarılı.");
        fetchRoleGroups();
      } else {
        toast.error(response?.Message || "Silme başarısız.");
      }
    } catch (error) {
      const msg = error?.response?.data?.Message || "Silme sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchRoleGroups();
  }, []);

  return (
    <div>
      <h2>Rol Grupları</h2>
      <Button type="primary" onClick={() => setIsModalOpen(true)}>
        Yeni Grup Ekle
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={roleGroups}
        columns={[
          { title: "Grup Adı", dataIndex: "name" },
          { title: "Açıklama", dataIndex: "description" },
          {
            title: "İşlem",
            render: (text, record) => (
              <>
                <Button
                  onClick={() => {
                    setEditingGroup(record);
                    form.setFieldsValue(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Güncelle
                </Button>
                <Button
                  danger
                  onClick={() => {
                    setDeletingGroup(record);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Sil
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Ekle/Güncelle Modal */}
      <Modal
        title={editingGroup ? "Grubu Güncelle" : "Yeni Grup Ekle"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingGroup(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleAddOrUpdate} layout="vertical">
          <Form.Item name="name" label="Grup Adı" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>

      {/* Silme Modalı */}
      <Modal
        title="Silme işlemini onaylıyor musunuz?"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onOk={() => {
          if (deletingGroup) {
            handleDelete(deletingGroup.id);
            setIsDeleteModalOpen(false);
          }
        }}
        okText="Evet, Sil"
        okType="danger"
        cancelText="Vazgeç"
      >
        <p>"{deletingGroup?.name}" adlı grup silinecek. Onaylıyor musunuz?</p>
      </Modal>
    </div>
  );
};

export default RoleGroups;
